import { apiClient } from '../../../../helpers/api_helper';

export const AddCustomerData = async (data: any) => {
    try {
        const response = await apiClient.post(`/api/v1/Customer/InsertCustomer`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const AddAllCustomerData = async () => {
    try {
        const response = await apiClient.get(`/api/v1/Customer/GetAllCustomerGrid?page=1&limit=50`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};


export const GetOldGoldRateByKaratIdApi = async (karatId: any) => {
    try {
        const response = await apiClient.get(`/api/v1/GoldRateMaster/GetTodaysGoldRateMaster?ktId=${karatId}`);
        if (response.status == 200) {
            return response.data;
        }
    } catch (error: any) {
        const message =
            error?.response?.data?.message || error?.message || "Unknown error occurred";
        throw new Error(message);
    }
};

export const GetDiscountAndGoldRateDetailsForCustomOrderApi = async (
    materialId: string,
    ktId?: string
) => {
    try {
        const params = new URLSearchParams();

        params.append("materialId", materialId);

        if (ktId && ktId.trim().length > 0) {
            params.append("ktId", ktId.trim());
        }

        const response = await apiClient.get(
            `/api/v1/EstimatePayment/GetDiscountAndGoldRateDetailsForCustomOrder?${params.toString()}`
        );
        return response;
    } catch (error: any) {
        const message =
            error?.response?.data?.message || error?.message || "Unknown error occurred";
        throw new Error(message);
    }
};

export const GetKaratSelectList = async () => {
    try {
        const response = await apiClient.get(`/api/v1/Karat/GetKaratSelectList`);
        return response.data;
    } catch (error: any) {
        const message =
            error?.response?.data?.message || error?.message || "Unknown error occurred";
        throw new Error(message);
    }
};

export const GetStyleList = async () => {
    try {
        const response = await apiClient.get(`/api/v1/StylesMaster/GetStylesSelectList`);
        return response.data;
    } catch (error: any) {
        const message =
            error?.response?.data?.message || error?.message || "Unknown error occurred";
        throw new Error(message);
    }
};
export const GetCollectionList = async () => {
    try {
        const response = await apiClient.get(`/api/v1/Collection/GetCollectionSelectList`);
        return response.data;
    } catch (error: any) {
        const message =
            error?.response?.data?.message || error?.message || "Unknown error occurred";
        throw new Error(message);
    }
};
export const GetCategroyList = async () => {
    try {
        const response = await apiClient.get(`/api/v1/Category/GetCategorySelectList`);
        return response.data;
    } catch (error: any) {
        const message =
            error?.response?.data?.message || error?.message || "Unknown error occurred";
        throw new Error(message);
    }
};

export const GetSalesPersonList = async () => {
    try {
        const response = await apiClient.get(`/api/v1/sales/GetSalesPersonSelectList`);
        return response.data;
    } catch (error: any) {
        const message =
            error?.response?.data?.message || error?.message || "Unknown error occurred";
        throw new Error(message);
    }
};

export const GetDimondClarityList = async () => {
    try {
        const response = await apiClient.get(`/api/v1/DiamondShape/GetDiamondClaritySelectList`);
        return response.data;
    } catch (error: any) {
        const message =
            error?.response?.data?.message || error?.message || "Unknown error occurred";
        throw new Error(message);
    }
};
// export const GetDimondStyleNoList = async () => {
//     try {
//         const response = await apiClient.get(`/api/v1/StylesMaster/GetStylesSelectList`);
//         return response.data;
//     } catch (error: any) {
//         const message =
//             error?.response?.data?.message || error?.message || "Unknown error occurred";
//         throw new Error(message);
//     }
// };

export const GetMrpTypeList = async () => {
    try {
        const response = await apiClient.get(`/api/v1/ConsumerOffers/GetMrpTypeSelectList`);
        return response.data;
    } catch (error: any) {
        const message =
            error?.response?.data?.message || error?.message || "Unknown error occurred";
        throw new Error(message);
    }
};
export const GetMaterialTypeList = async () => {
    try {
        const response = await apiClient.get(`/api/v1/MaterialType/GetMaterialTypeSelectList`);
        return response.data;
    } catch (error: any) {
        const message =
            error?.response?.data?.message || error?.message || "Unknown error occurred";
        throw new Error(message);
    }
};


export const CreateEstimate = async (data: any) => {
    try {
        const response = await apiClient.post(`/api/v1/EstimatePayment/CreateEstimatePaymentDetails`, data);
        return response;
    } catch (error: any) {
        const message =
            error?.response?.data?.message || error?.message || "Unknown error occurred";
        throw new Error(message);
    }
};


export const FreezeGoldRate = async () => {
    try {
        const response = await apiClient.get(`/api/v1/SalesEntry/GetStoreDiscountDetails`);
        return response;
    } catch (error: any) {
        const message =
            error?.response?.data?.message || error?.message || "Unknown error occurred";
        throw new Error(message);
    }
};

export const GetPaymentType = async () => {
    try {
        const response = await apiClient.get('api/v1/Payment/GetPaymentTypeSelectList')
        return response
    } catch (error: any) {
        const message =
            error?.response?.data?.message || error?.message || "Unknown error occurred";
        throw new Error(message);
    }
}

export const checkProductAvailble = async (data: any) => {
    try {
        if (!(data?.styleNo && data?.ktId)) {
            return
        }
        const response = await apiClient.get(`/api/v1/InterStoreTransfer/CheckInterStoreProductIsPresent?styleNo=${data?.styleNo}&ktId=${data?.ktId}`)
        return response;
    } catch (error: any) {
        const message =
            error || error?.message || "Unknown error occurred";
        throw new Error(message);
    }
}
